export const CONST_PISCO_PURO = "puro"
export const CONST_PISCO_ACHOLADO = "acholado"
export const CONST_PISCO_MOSTO_VERDE = "mosto-verde"
